/*
MapMixins to process Google Map Markers
TODO Needs to clear cache and generally be tidier
but it works (enough) for now.
-------------------------------------------- */

import axios from '@/lib/axiosClient'

import {GOOGLE_API_KEY} from '@/components/Data'

import NumberMixins from '@/mixins/NumberMixins'

// const testPlaces = require('@/components/maps/test-places.json')


export default {

  mixins: [NumberMixins],

  methods: {
    resetBounds () {

      this.bounds = new window.google.maps.LatLngBounds()

    },

    loadPoi (lat, lng, radius = null, type = null) {

      if (!lat || !lng) {
        this.$message({message: 'Unable to load Places of Interest: invalid lat or lng values',
          type: 'warning'
        })
        return
      }

      let url = 'https://maps.googleapis.com/maps/api/place/nearbysearch/json?location=' + lat + ',' + lng + (radius ? '&radius=' + radius : '') + (type ? '&type=' + type : '') + '&key=' + GOOGLE_API_KEY

      console.log('loadPoi', url)
/*
      var xmlHttp = new XMLHttpRequest()
      xmlHttp.open('GET', url, false)  // false for synchronous request
      xmlHttp.send(null)
      console.log(xmlHttp.responseText)
*/
      axios.get(url).then(response => {
        this.places = response.results
      })
      .catch(e => {
        this.$message({message: 'Unable to load Places of Interest [' + e + ']',
          type: 'error'
        })
      })
    },

    // -- Loading of markers from URLs....
    loadMapMarkers (url, bounds) {

      if (!url) {
        return
      }

      if (this.markers.length > 0) {
        this.totalMarkers = 0
        this.currentPage = 0
        this.processing = true
        this.showProgress = true
        this.markers = []
      }

      this.processUrl(url, bounds)
    },



    processUrl (url, bounds) {
      if (!url) {
        this.$events.fire(this.finishedEvent)
        return
      }

      axios.get(url, bounds).then(response => {
        if (!this.processing) {
          this.processing = true
        }

        if (this.totalMarkers < response.data.total) {
          this.totalMarkers = response.data.total

          if (!this.sharerMarkers) {
            this.sharerMarkers = response.data.total
          }
        }

        if (this.totalPages < response.data.last_page) {
          this.totalPages = response.data.last_page
        }

        this.currentPage = response.data.current_page
        this.mapUrl = response.data.next_page_url

        this.getMapMarkers(response.data.data, bounds)

        if (this.currentPage < this.totalPages) {
          this.processUrl(this.mapUrl, bounds)
        } else {
          this.$events.fire(this.finishedEvent)
          this.processing = false
        }
      })
      .catch(e => {
        this.processing = false
        this.$events.fire(this.finishedEvent)
        this.$message({message: 'Unable to load map [' + e + ']',
          type: 'error'
        })
      })
    },



    getMapMarkers (data, bounds, center = null) {
      if (!data || !this.processing) {
        return
      }

      for (let item in data) {
        let marker = {
          content: {
            id: data[item].id,
            status: data[item].status,
            siteId: data[item].siteId,
            siteName: data[item].siteName,
            structureType: data[item].structureType,
            structureHeight: data[item].structureHeight,
            handover: data[item].handover,
            tenancyExpiry: data[item].landExpiry,
            expiryDays: data[item].expiryDays,
            sharers: data[item].sharers
          },
          position: {lat: Number(data[item].latitude), lng: Number(data[item].longitude)},
          visible: false
        }

        this.markers.push(marker)

        if (bounds && marker.position) {
          bounds.extend(marker.position)
        }

      }  // for


      let progress = {
        percent: Math.round((this.currentPage / this.totalPages) * 100, 0),
        total: this.totalMarkers
      }

      this.$events.fire(this.progressEvent, progress)
    },


    // Various map icons....
    dragIcon () {
      return 'static/map/default-48.png'
    },

    defaultIcon () {
      return 'static/map/marker.png'
    },

    greyIcon () {
      return 'static/map/grey-dot.png'
    },

    pinkIcon () {
      return 'static/map/pink-dot.png'
    },

    yellowIcon () {
      return 'static/map/yellow-dot.png'
    },

    // 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
    redIcon () {
      return 'static/map/red-dot.png'
    },

    greenIcon () {
      return 'static/map/green-dot.png'
    },

    blueIcon () {
      return 'static/map/blue-dot.png'
    }
  },



  data () {
    return {
//      changingWidth: 200,
//      changingHeight: 200,
      bounds: null,
      progressEvent: 'progress',
      finishedEvent: 'finished',
      sharerMarkers: null,
      totalMarkers: 0,
      currentPage: 0,
      totalPages: 0,
      processing: false,
      mapUrl: null,
      markers: [],
      places: [],
      poiTypes: [
        ['accounting', 'fa fa-calculator'],
        ['airport', 'fa fa-plane-departure'],
        ['amusement_park', 'fa fa-route'],
        ['aquarium', 'fa fa-water'],
        ['art_gallery', 'fa fa-palette'],
        ['atm', 'fa fa-credit-card'],
        ['bakery', 'fa fa-bread-slice'],
        ['bank', 'fa fa-landmark'],
        ['bar', 'fa fa-glass-cheers'],
        ['beauty_salon', 'fa fa-leaf'],
        ['bicycle_store', 'fa fa-biking'],
        ['book_store', 'fa fa-book'],
        ['bowling_alley', 'fa fa-bowling-ball'],
        ['bus_station', 'fa fa-bus'],
        ['cafe', 'fa fa-mug-hot'],
        ['campground', 'fa fa-campground'],
        ['car_dealer', 'fa fa-car-side'],
        ['car_rental', 'fa fa-key'],
        ['car_repair', 'fa fa-car-crash'],
        ['car_wash', 'fa fa-car'],
        ['casino', 'fa fa-dice'],
        ['cemetery', 'fa fa-dizzy'],
        ['church', 'fa fa-church'],
        ['city_hall', 'fa fa-building'],
        ['clothing_store', 'fa fa-tshirt'],
        ['convenience_store', 'fa fa-shopping-basket'],
        ['courthouse', 'fa fa-balance-scale-right'],
        ['dentist', 'fa fa-tooth'],
        ['department_store', 'fa fa-shopping-cart'],
        ['doctor', 'fa fa-stethoscope'],
        ['drugstore', 'fa fa-capsules'],
        ['establishment', 'fa fa-map-marker-alt'],
        ['electrician', 'fa fa-plug'],
        ['electronics_store', 'fa fa-mobile-alt'],
        ['embassy', 'fa fa-passport'],
        ['fire_station', 'fa fa-fire-extinguisher'],
        ['florist', 'fa fa-seedling'],
        ['funeral_home', 'fa fa-skull-crossbones'],
        ['furniture_store', 'fa fa-couch'],
        ['gas_station', 'fa fa-gas-pump'],
        ['general_contractor', 'fa fa-wrench'],
        ['gym', 'fa fa-dumbbell'],
        ['hair_care', 'fa fa-pump-soap'],
        ['hardware_store', 'fa fa-tools'],
        ['hindu_temple', 'fa fa-gopuram'],
        ['home_goods_store', 'fa fa-blender-phone'],
        ['hospital', 'fa fa-hospital-symbol'],
        ['insurance_agency', 'fa fa-file-invoice'],
        ['jewelry_store', 'fa fa-gem'],
        ['laundry', 'fa fa-pump-soap'],
        ['lawyer', 'fa fa-balance-scale-left'],
        ['library', 'fa fa-book-open'],
        ['light_rail_station', 'fa fa-shuttle-van'],
        ['liquor_store', 'fa fa-wine-bottle'],
        ['local_government_office', 'fa fa-city'],
        ['locksmith', 'fa fa-user-lock'],
        ['lodging', 'fa fa-hotel'],
        ['meal_delivery', 'fa fa-pizza-slice'],
        ['meal_takeaway', 'fa fa-hamburger'],
        ['mosque', 'fa fa-mosque'],
        ['movie_rental', 'fa fa-film'],
        ['movie_theater', 'fa fa-ticket-alt'],
        ['moving_company', 'fa fa-truck'],
        ['museum', 'fa fa-archway'],
        ['night_club', 'fa fa-cocktail'],
        ['painter', 'fa fa-paint-roller'],
        ['park', 'fa fa-tree'],
        ['parking', 'fa fa-parking'],
        ['pet_store', 'fa fa-dog'],
        ['pharmacy', 'fa fa-prescription'],
        ['physiotherapist', 'fa fa-user-md'],
        ['plumber', 'fa fa-faucet'],
        ['political', 'fa fa-award'],
        ['police', 'fa fa-gavel'],
        ['post_office', 'fa fa-mail-bulk'],
        ['primary_school', 'fa fa-chalkboard'],
        ['real_estate_agency', 'fa fa-house-user'],
        ['restaurant', 'fa fa-utensils'],
        ['roofing_contractor', 'fa fa-house-damage'],
        ['rv_park', 'fa fa-caravan'],
        ['school', 'fa fa-school'],
        ['secondary_school', 'fa fa-chalkboard-teacher'],
        ['shoe_store', 'fa fa-shoe-prints'],
        ['shopping_mall', 'fa fa-gifts'],
        ['spa', 'fa fa-spa'],
        ['stadium', 'fa fa-volleyball-ball'],
        ['storage', 'fa fa-boxes'],
        ['store', 'fa fa-store'],
        ['subway_station', 'fa fa-subway'],
        ['supermarket', 'fa fa-shopping-cart'],
        ['synagogue', 'fa fa-synagogue'],
        ['taxi_stand', 'fa fa-taxi'],
        ['tourist_attraction', 'fa fa-map-signs'],
        ['train_station', 'fa fa-train'],
        ['transit_station', 'fa fa-bus-alt'],
        ['travel_agency', 'fa fa-umbrella-beach'],
        ['university', 'fa fa-graduation-cap'],
        ['veterinary_care', 'fa fa-paw'],
        ['zoo', 'fa fa-frog']
      ]
    }
  },


  created () {
    this.resetBounds()
  }

}
